import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function NotFound() {
  return (
    <div className="min-h-screen bg-stone-950 text-stone-100 relative">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(900px_circle_at_50%_0%,rgba(34,211,238,0.1),transparent_55%)]" />
      <Navigation />
      <div className="relative flex min-h-[70vh] items-center justify-center px-4 py-16 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8 text-center card-glass rounded-3xl border border-white/10 p-10">
          <h1 className="text-6xl font-semibold tracking-tight text-white">404</h1>
          <h2 className="text-2xl font-semibold tracking-tight text-stone-100">Page not found</h2>
          <p className="text-sm text-stone-400">
            The page you are looking for does not exist or has been moved.
          </p>
          <div>
            <Link
              to="/"
              className="inline-flex items-center rounded-xl bg-cyan-400 px-6 py-3 text-sm font-semibold text-slate-950 hover:bg-cyan-300 transition-colors"
            >
              Return home
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NotFound;
